// src/App.js
import React, { useState } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import PrivateRoute from "./components/PrivateRoute";
import AppShell from "./layouts/AppShell";

/* Pages */
import Home from "./pages/home";
import Devis from "./pages/devis";
import Factures from "./pages/factures";
import CreerDevis from "./pages/CreerDevis";
import CreerFacture from "./pages/CreerFacture";
import Clients from "./pages/Clients";
import Personnaliser from "./pages/personnaliser";
import Designations from "./pages/Designations";

import Profil from "./settings/profil";
import Abonnement from "./settings/abonnement";
import Logout from "./pages/logout";
import Auth from "./pages/Auth";
import ResetPassword from "./pages/ResetPassword";
/* Centre documents (nouvelle arbo) */
import Documents from "./pages/Documents";
import DocumentsCentreDevis from "./pages/DocumentsCentreDevis";
import DocumentsCentreFactures from "./pages/DocumentsCentreFactures";

/* Affichages & variantes factures */
import AfficherDevis from "./pages/AfficherDevis";
import AfficherFacture from "./pages/AfficherFacture";
import FactureAcompte from "./pages/FactureAcompte";
import FacturePartielle from "./pages/FacturePartielle";
import FactureFinale from "./pages/FactureFinale";

/* Nouvelle page : modèles d’e-mails */
import EmailTemplates from "./pages/EmailTemplates";

function App() {
  const [infosSociete, setInfosSociete] = useState({});

  return (
    <>
      <ToastContainer position="top-right" autoClose={3000} />

      <Router>
        <Routes>
          {/* Publiques */}
          <Route path="/login" element={<Auth />} />
          <Route path="/register" element={<Auth />} />
          <Route path="/reset-password" element={<ResetPassword />} />

          {/* Accueil (protégé) */}
          <Route
            path="/"
            element={
              <PrivateRoute>
                <AppShell><Home /></AppShell>
              </PrivateRoute>
            }
          />

          {/* ===== Centre Documents ===== */}
          <Route
            path="/documents"
            element={
              <PrivateRoute>
                <AppShell><Documents /></AppShell>
              </PrivateRoute>
            }
          />
          <Route
            path="/documents-centre/devis"
            element={
              <PrivateRoute>
                <AppShell><DocumentsCentreDevis /></AppShell>
              </PrivateRoute>
            }
          />
          <Route
            path="/documents-centre/factures"
            element={
              <PrivateRoute>
                <AppShell><DocumentsCentreFactures /></AppShell>
              </PrivateRoute>
            }
          />
          <Route path="/documents-centre" element={<Navigate to="/documents" replace />} />

          {/* Anciennes pages (si encore utilisées) */}
          <Route
            path="/devis"
            element={
              <PrivateRoute>
                <AppShell><Devis /></AppShell>
              </PrivateRoute>
            }
          />
          <Route
            path="/factures"
            element={
              <PrivateRoute>
                <AppShell><Factures /></AppShell>
              </PrivateRoute>
            }
          />

          {/* Création */}
          <Route
            path="/creer-devis"
            element={
              <PrivateRoute>
                <AppShell><CreerDevis infosSociete={infosSociete} /></AppShell>
              </PrivateRoute>
            }
          />
          <Route
            path="/creer-facture"
            element={
              <PrivateRoute>
                <AppShell><CreerFacture infosSociete={infosSociete} /></AppShell>
              </PrivateRoute>
            }
          />

          {/* Clients / Désignations / Personnaliser */}
          <Route
            path="/clients"
            element={
              <PrivateRoute>
                <AppShell><Clients /></AppShell>
              </PrivateRoute>
            }
          />
          <Route
            path="/designations"
            element={
              <PrivateRoute>
                <AppShell><Designations /></AppShell>
              </PrivateRoute>
            }
          />
          <Route
            path="/personnaliser"
            element={
              <PrivateRoute>
                <AppShell>
                  <Personnaliser setInfosSociete={setInfosSociete} infosSociete={infosSociete} />
                </AppShell>
              </PrivateRoute>
            }
          />

          {/* Modèles d’e-mails */}
          <Route
            path="/email-templates"
            element={
              <PrivateRoute>
                <AppShell><EmailTemplates /></AppShell>
              </PrivateRoute>
            }
          />

          {/* Paramètres */}
          <Route
            path="/parametres/profil"
            element={
              <PrivateRoute>
                <AppShell><Profil /></AppShell>
              </PrivateRoute>
            }
          />
          <Route
            path="/parametres/abonnement"
            element={
              <PrivateRoute>
                <AppShell><Abonnement /></AppShell>
              </PrivateRoute>
            }
          />
          <Route
            path="/logout"
            element={
              <PrivateRoute>
                <AppShell><Logout /></AppShell>
              </PrivateRoute>
            }
          />

          {/* Affichages & variantes */}
          <Route
            path="/afficher-devis"
            element={
              <PrivateRoute>
                <AppShell><AfficherDevis /></AppShell>
              </PrivateRoute>
            }
          />
          <Route
            path="/afficher-facture"
            element={
              <PrivateRoute>
                <AppShell><AfficherFacture /></AppShell>
              </PrivateRoute>
            }
          />
          <Route
            path="/facture-acompte"
            element={
              <PrivateRoute>
                <AppShell><FactureAcompte /></AppShell>
              </PrivateRoute>
            }
          />
          <Route
            path="/facture-partielle"
            element={
              <PrivateRoute>
                <AppShell><FacturePartielle /></AppShell>
              </PrivateRoute>
            }
          />
          <Route
            path="/facture-finale"
            element={
              <PrivateRoute>
                <AppShell><FactureFinale /></AppShell>
              </PrivateRoute>
            }
          />

          {/* 404 */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Router>
    </>
  );
}

export default App;
